module.exports = __webpack_public_path__ + "static/img/rtwman.4e14bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/20210918/rtwman.jpg
// module id = wxvC
// module chunks = 1